import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import Fuse from 'fuse.js';
import pick from 'lodash/pick';
import get from 'lodash/get';
import draggable from 'vuedraggable';
import { Fragment } from 'vue-fragment';
import { TablePager } from '@/api/pager';
import { TextField } from '@/components/fields';
export default {
  name: 'OTable',
  components: {
    draggable: draggable,
    Fragment: Fragment,
    TextField: TextField
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    data: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footerData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 100
    },
    striped: {
      type: Boolean,
      default: true
    },
    collapse: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: function _default() {
        return this.$t('components.elements.table.noData');
      }
    },
    tableId: {
      type: String,
      default: null
    },
    containerClass: {
      type: String,
      default: ''
    },
    tableClass: {
      type: [String, Object, Array],
      default: 'w-full overflow-hidden table'
    },
    theadClass: {
      type: Object,
      default: function _default() {
        return {
          thead: 'border-b dark:border-gray-900',
          tr: 'border-blue-700',
          th: 'font-normal p-4 pb-3 bg-gray-50 dark:bg-gray-900 text-gray-700 dark:text-white text-base sticky top-0',
          content: 'flex item-center'
        };
      }
    },
    tbodyClass: {
      type: Object,
      default: function _default() {
        return {
          tfoot: '',
          tr: 'transition-all duration-200 bg-gray-50 dark:bg-gray-900',
          td: 'py-3 px-4 text-base',
          stripe: 'transition-all duration-200 bg-gray-50/50 dark:bg-white/[0.01]'
        };
      }
    },
    tfootClass: {
      type: Object,
      default: function _default() {
        return {
          tbody: '',
          tr: '',
          td: 'p-3'
        };
      }
    },
    paginationClass: {
      type: String,
      default: ''
    },
    filter: {
      type: Boolean,
      default: false
    },
    reorder: {
      type: Boolean,
      default: false
    },
    reorderActive: {
      type: Boolean,
      default: null
    },
    group: {
      type: String,
      default: 'o-table'
    },
    responsive: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: false
    },
    responsiveBreakpoint: {
      type: Number,
      default: 768
    },
    filterKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sortKeys: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      ready: !this.responsive,
      windowWidth: null,
      current: 1,
      selected: [],
      indeterminate: false,
      query: '',
      sort: {
        key: null,
        order: null
      },
      page: [],
      undo: null,
      reorderActiveLocal: false
    };
  },
  computed: {
    rows: {
      get: function get() {
        if (this._reorderActive) {
          if (this.isTablePagerData) {
            return this.data.items;
          } else {
            return this.data;
          }
        }
        return this.page;
      },
      set: function set(data) {
        if (this._reorderActive) {
          if (this.isTablePagerData) {
            this.data.items = data;
          } else {
            this.$emit('update:data', data);
          }
        } else {
          this.page = data;
        }
      }
    },
    _reorderActive: {
      get: function get() {
        if (this.reorderActive !== null) {
          return this.reorderActive;
        } else {
          return this.reorderActiveLocal;
        }
      },
      set: function set(data) {
        if (this.reorderActive !== null) {
          this.$emit('update:reorderActive', data);
        } else {
          this.reorderActiveLocal = data;
        }
      }
    },
    items: function items() {
      var data = this.data;
      if (this.isTablePagerData) {
        return data.items;
      }
      return data;
    },
    sorted: function sorted() {
      var key = this.sort.key;
      var order = this.sort.order;
      var filter = this.filter;
      var query = this.query;
      var items = this.items;
      if (filter && query) {
        var fuse = new Fuse(items, {
          keys: this.filterKeys
        });
        var results = fuse.search(query);
        items = results.map(function (_ref) {
          var item = _ref.item;
          return item;
        });
      }
      var currencySymbol = this.$auth.info.location.currencySymbol;
      if (key) {
        var sorted = _toConsumableArray(items).sort(function (a, b) {
          a = get(a, key);
          b = get(b, key);
          if (typeof a === 'string' && a.startsWith(currencySymbol)) {
            var regex = new RegExp('(^\\' + currencySymbol + '|,)', 'g');
            a = Number(a.replace(regex, ''));
          } else if (typeof a === 'string' && !isNaN(a)) {
            a = Number(a);
          }
          if (typeof b === 'string' && b.startsWith(currencySymbol)) {
            var regex = new RegExp('(^\\' + currencySymbol + '|,)', 'g');
            b = Number(b.replace(regex, ''));
          } else if (typeof b === 'string' && !isNaN(b)) {
            b = Number(b);
          }
          if (a < b) {
            return order !== 'desc' ? 1 : -1;
          }
          if (a > b) {
            return order !== 'desc' ? -1 : 1;
          }
          return 0;
        });
        return sorted;
      }
      return items;
    },
    pages: function pages() {
      return this.data.pages || Math.ceil(this.sorted.length / this.limit) || 0;
    },
    renderResponsive: function renderResponsive() {
      return this.responsive && this.windowWidth && this.windowWidth < this.responsiveBreakpoint;
    },
    normalizedHeaders: function normalizedHeaders() {
      return this.headers.map(function (header) {
        if (typeof header === 'string') {
          return {
            text: header
          };
        }
        return header;
      });
    },
    normalizedFooterData: function normalizedFooterData() {
      return this.footerData.map(function (footer) {
        if (typeof footer === 'string') {
          return {
            text: footer
          };
        }
        return footer;
      });
    },
    headersValues: function headersValues() {
      return this.headers.filter(function (h) {
        return h.value;
      }).map(function (h) {
        return h.value;
      });
    },
    showHeader: function showHeader() {
      return !this.hideHeader;
    },
    currentClass: function currentClass() {
      var classes = ["".concat(this.$options._componentTag)];
      if (this.tableClass) {
        classes.push(this.tableClass);
      }
      return classes;
    },
    counter: function counter() {
      var current = this.current;
      var limit = this.limit;
      var total = this.data.total || this.items.length;
      var position = current * limit - limit;
      var from = position + 1;
      var to = position + limit > total ? total : position + limit;
      return {
        from: from,
        to: to,
        total: total
      };
    },
    isTablePagerData: function isTablePagerData() {
      return this.data instanceof TablePager;
    }
  },
  watch: {
    current: function current(page) {
      if (this.isTablePagerData) {
        this.data.load(page);
      }
      this.updatePage();
    },
    value: function value(_value) {
      this.selected = _value;
    },
    selected: function selected(_selected) {
      this.indeterminate = !!_selected.length;
      this.$emit('input', _selected);
    },
    sorted: {
      handler: function handler() {
        this.updatePage();
      },
      immediate: true
    },
    _reorderActive: function _reorderActive(reorderActive) {
      if (reorderActive) {
        this.undo = this.page;
      }
    },
    sort: {
      handler: function handler(sort) {
        this.$emit('sort', sort);
      },
      deep: true
    },
    limit: function limit() {
      this.updatePage();
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.responsive) {
      this.windowWidth = window.innerWidth;
      this.ready = true;
      window.addEventListener('resize', function () {
        _this.windowWidth = window.innerWidth;
      });
    }
    if (this.sortKeys) {
      this.sort.key = this.sortKeys.key;
      this.sort.order = this.sortKeys.order;
    }
  },
  methods: {
    getProp: function getProp(obj, prop) {
      return prop.split('.').reduce(function (r, e) {
        return r[e];
      }, obj);
    },
    getRowColumns: function getRowColumns(row) {
      if (!this.headersValues.length) {
        return row;
      }
      return pick(row, this.headersValues);
    },
    getCell: function getCell(cell) {
      if (cell === null || cell === undefined) {
        return '';
      }
      if (typeof cell === 'string') {
        return cell;
      }
      if (_typeof(cell) === 'object') {
        return Object.values(cell)[0] || '-';
      }
      return '-';
    },
    selectAll: function selectAll() {
      var items = this.items;
      if (items.length === this.selected.length) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },
    sortData: function sortData(key) {
      var current = this.sort.key;
      var order = this.sort.order;
      this.sort = {
        key: current === key && order === 'asc' ? null : key,
        order: current === key && order === 'asc' ? null : order === 'desc' ? 'asc' : 'desc'
      };
    },
    toggle: function toggle(index) {
      var collapse = this.$refs['collapse' + index];
      if (collapse && collapse[0]) {
        collapse[0].toggle();
      }
    },
    updatePage: function updatePage() {
      var page = this.sorted;
      if (this.isTablePagerData) {
        this.page = page;
      } else {
        var current = (this.current - 1) * this.limit;
        this.page = page.slice(current, current + this.limit);
      }
    },
    handleReorderClick: function handleReorderClick() {
      this.$emit('reorder-click');
      this._reorderActive = true;
    },
    handleReorderCancel: function handleReorderCancel() {
      this.$emit('reorder-cancel');
      this.page = this.undo;
      this._reorderActive = false;
    },
    handleReorderConfirm: function handleReorderConfirm() {
      this.$emit('reorder-confirm');
      this._reorderActive = false;
    }
  }
};